module.exports = __webpack_public_path__ + "static/img/mw.5799d8d2.svg";